import React, { FC, useEffect } from "react";
import { Alert } from "antd";
import { Trans, useTranslation } from "react-i18next";
import useMeasure from "react-use-measure";
import useNavigateWithState from "../../../common/navigate/hooks/useNavigateWithState";
import "./DuplicateAlert.scss";

type Props = {
  isDuplicate?: boolean;
  duplicateOfId?: string;
  duplicateOfName?: string;
  setHeight: (height: number) => void;
};

const DuplicateAlert: FC<Props> = ({
  isDuplicate,
  duplicateOfId,
  duplicateOfName,
  setHeight,
}) => {
  const { t } = useTranslation("annotationSideControls", {
    keyPrefix: "alert.duplicate",
  });
  const { navigateWithState } = useNavigateWithState();

  const [refHeightContainer, { height }] = useMeasure();

  useEffect(() => {
    setHeight(height);

    return () => {
      setHeight(0);
    };
  }, [height, setHeight]);

  if (!isDuplicate || !duplicateOfId) {
    return null;
  }

  return (
    <div ref={refHeightContainer}>
      <Alert
        className="duplicate__alert-warning"
        title={t("message")}
        description={
          <Trans
            t={t}
            i18nKey="description"
            values={{ name: duplicateOfName }}
            components={{
              nameLink: (
                <button
                  type="button"
                  className="duplicate__alert-link"
                  onClick={(event) => {
                    event.stopPropagation();
                    navigateWithState(`/detail/${duplicateOfId}`);
                  }}
                />
              ),
            }}
          />
        }
        type="warning"
        icon={<i className="bi bi-flag-fill duplicate__alert-icon" />}
        showIcon
      />
    </div>
  );
};

export default DuplicateAlert;
